export default function getDashboardLink(selectionContext = {}, options = {}) {
  const { warehouseDropdownEnabled = false } = options;
  const selectedPage = localStorage.getItem("selectedPage") || "capture-inventory";
  const clientId = selectionContext.client_id;
  const projectId = selectionContext.project_id;

  const hasProject = projectId && projectId !== "all";

  // Warehouse-dropdown companies never expose a client selector, so they must
  // never resolve to a real client-scoped route. selection_context.client_id
  // may be backfilled with the selected project's client id, but for these
  // companies it should be ignored: route to the project when one is selected,
  // otherwise to the neutral `/clients/null` landing.
  if (warehouseDropdownEnabled) {
    return hasProject ? `/projects/${projectId}/${selectedPage}` : `/clients/null/${selectedPage}`;
  }

  if (!clientId) {
    return `/clients/null/${selectedPage}`;
  }

  if (hasProject) {
    return `/projects/${projectId}/${selectedPage}`;
  }

  return `/clients/${clientId}/${selectedPage}`;
}
